<div class="dashboard-page">
  @if (dashboard) {
    <ysh-page-header [title]="$safeNavigationMigration(dashboard?.title)" subtitle="Welcome, {{ currentCompany?.name || currentUser?.name }}!"/>
    <ysh-grid [tiles]="gridTiles" [numberOfColumns]="$safeNavigationMigration(dashboard?.numColumns)" [numberOfRows]="$safeNavigationMigration(dashboard?.numRows)"/>
  }
</div>
